import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { connect } from "react-redux";
import { Field, Form, FormSpy } from 'react-final-form';
import { OnChange } from "react-final-form-listeners";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import { bindActionCreators } from "redux";
import {
    hideTicketForm,
    persistTicketFormData,
    showTicketForm,
    updateTicketFormData,
    updateTicketInList
} from "../../../actions/tickets"

import "./TicketForm.css"
import { FieldGroup } from "./Groups/FieldGroup";
import { RadioField } from "./Fields/RadioField";

import { InputField } from "./Fields/InputField";
import { Condition } from "./Conditionals/Condition";

import { Spot } from "./Conditionals/Spot";
import { AdvertisingForm } from "./AdvertisingForm/AdvertisingForm"

import { CorporateForm } from "./CorporateForm/CorporateForm"
import { atLeastTwoWeeks, composeValidators, pickOne, requiredField } from "./Validation";
import { BackendURL } from "../../Constants/AppData";

import { DateField } from "./Fields/DateField";
import {
    WerfenColor,
    WerfenColor2,
    WerfenColorLight,
    WerfenColorMid,
    White
} from "../../Constants/ColorChart";

const StyledModal = styled( Modal )`
    & .modal-dialog.modal-lg{
        max-width: 1200px;
    }
`

const StyledModalHeader = styled( Modal.Header )`
    & .close{
        border: 0 none transparent;
        font-size: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 15px;
        top: 10px;
        width: 40px;
        height: 40px;
        opacity: 0.5;
        &:hover {
            opacity: 1;
        }
        & .sr-only {
            display: none;
        }
    }
`

const StyledForm = styled.form`
    & .form-group {
        margin-bottom: 15px;
    }
    & .btn-primary:disabled, 
    & .btn-primary.disabled{
        background-color: #fff;
        border-color: #ccc;
        color: #333;
        font-size: 0.875rem;
    }
    & .checkbox, 
    & .radio {
        position: relative;
        display: block;
        margin-top: 10px;
        margin-bottom: 10px;
    }
`

const StyledButton = styled( Button )`
    &.button__request {
        background: ${ WerfenColorLight }!important;
        color: ${ White };
        border-color: ${ WerfenColorLight }!important;
        outline:0;
        &:hover,
        &:focus{
            background: ${ WerfenColorLight }!important;
            color: ${ White };
            border-color: ${ WerfenColorLight };
            outline:0;
            box-shadow: unset;
            cursor: pointer;
            opacity: 0.9
        }
        &:active, 
        &:active:hover {
            background: ${ WerfenColor2 }!important;
            color: ${ White };
            border-color: ${ WerfenColor };
            outline:0;
            cursor: pointer;
            box-shadow: unset;
        }
    }
    
    &.btn.btn-primary {
        font-size: 22px;
        font-weight: 500;
        padding: 10px 125px;
        border-radius: 0;
        border-color: ${ WerfenColor };
        background-color: ${ WerfenColor };
        color: ${ White };
        margin-top:20px;
        &:hover{
            border-color: ${ WerfenColorMid };
            background-color: ${ WerfenColorMid };
            color: ${ White };
        }
        &:active{
            border-color: ${ WerfenColorMid };
            background-color: ${ WerfenColorMid };
            color: ${ White };
        }
        &:focus{
            border-color: ${ WerfenColorMid };
            background-color: ${ WerfenColorMid };
            color: ${ White };
            outline: 0;
            box-shadow: unset;
        }
        @media (max-width: 992px){
            padding: 10px;
            font-size: 14px;
        }
    }
    `

const fetchMaterialTypes = async () => {
    let myHeaders = new Headers();
    const URL = BackendURL + "/jsonapi/taxonomy_term/material_type?fields[taxonomy_term--material_type]=id,name";

    myHeaders.append( "Content-Type", "application/vnd.api+json" );
    myHeaders.append( "Accept", "application/vnd.api+json" );
    myHeaders.append( "Authorization", "Bearer " + window.localStorage.getItem( 'token' ) );

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return await fetch( URL, requestOptions );
}

const fetchTicketStatuses = async () => {
    let myHeaders = new Headers ();
    const URL = BackendURL + "/jsonapi/taxonomy_term/ticket_status?fields[taxonomy_term--material_type]=id,name";

    myHeaders.append ( "Content-Type", "application/vnd.api+json" );
    myHeaders.append ( "Accept", "application/vnd.api+json" );
    myHeaders.append ( "Authorization", "Bearer " + window.localStorage.getItem ( 'token' ) );

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return await fetch ( URL, requestOptions );
}

const TicketForm = ( props ) => {
    const { session } = props;
    const [ showConfirmPanel, setShowConfirmPanel ] = useState( false )
    const [ showVerification, setShowVerification ] = useState( false )
    const [ verificationMessage, setVerificationMessage ] = useState( false )
    const [ materialsList, setMaterialsList ] = useState( [] )
    const [ defaultTicketData, setDefaultTicketData ] = useState ( [] )
    const minimumDeadline = new Date();
    minimumDeadline.setDate( minimumDeadline.getDate() + 14 );

    useEffect( () => {
        fetchMaterialTypes()
            .then( response => response.json() )
            .then( result => {
                return result.data.map( item => {
                    return {
                        id: item.id,
                        name: item.attributes.name
                    }
                } )
            } )
            .then( ( data ) => {
                setMaterialsList( data )
            } )
            .catch( ( error ) => console.error( error ) )

        fetchTicketStatuses ()
            .then ( response => response.json () )
            .then ( result => {
                    return result.data.map ( item => {
                        return {
                            id: item.id,
                            name: item.attributes.name
                        }
                    } )
                }
            )
            .then ( statusesList => {
                setDefaultTicketData (
                    ( prevState => {
                        return {
                            ...prevState,
                            status: statusesList[0].id
                        }
                    } )
                )
            } )
            .catch ( error => console.error ( 'error fetching ticket statuses ', error ) )
    }, [] )

    const onSubmit = async ( values ) => {
        // const username = window.localStorage.getItem( "username" );
        const valuesKeys = Object.keys( values );

        let myHeaders = new Headers();
        let descriptionOutput = "";

        valuesKeys.forEach( (item, index) => {
            //console.info(item, values[item]);
            if ( item.toLowerCase().includes( "file" ) || item.toLowerCase().includes( "attachment" ) ) {
                const iterator = [ ...values[item] ];
                descriptionOutput += item + "\n"
                iterator.forEach( ( file, index ) => {
                    descriptionOutput += values[item][index].name + "\n";
                } );
                descriptionOutput += "\n"
            } else if ( item.includes( "__" ) ) {
                descriptionOutput += "";
            } else {
                descriptionOutput += item + "\n" + values[item]
                if( index + 1 !== valuesKeys.length ){
                    descriptionOutput += "\n\n"
                }
            }
        } )
        const boothFile = values["boothLayoutFile"] || [];
        const projectFile = values["projectAttachment"] || [];
        const translationFile = values["Translation File"] || [];
        const translationSpecialFile = values["translationSpecialFile"] || [];
        const attachments = [ ...boothFile, ...projectFile, ...translationFile, ...translationSpecialFile ];

        const objectToSend = {
            data: {
                "type": "ticket--ticket",
                "attributes": {
                    summary: values["Request Subject"],

                    /* PLAIN VALUES */
                    field_ticket_date_needed_by: values["When is the deadline for the request?"].toISOString().substr( 0, 10 ),
                    field_ticket_description: descriptionOutput,
                    field_ticket_resource: window.location.href,
                    field_ticket_original_requester:  values["Original Requester"] !==""? values["Original Requester"] :"DUMMY TEXT",
                        /* USER DATA PROVIDED BY BACKEND AT LOGIN (not actually needed so we shouldn't save them */
                    field_ticket_job_position: values["Job Position"] !== "" ? values["Job Position"] : "DUMMY TEXT",
                    field_ticket_phone: values["Phone Number"] !== "" ? values["Phone Number"] : "DUMMY TEXT",
                    field_ticket_company: values["Company"] !== "" ? values["Company"] : "DUMMY TEXT",
                    field_ticket_email: [ { value: values["Email"] !== "" && values["Email"] !== "N/A" ? values["Email"] : "DUMMY@T.EXT" } ],
                },
                relationships: {
                    /* READ FROM QUERY */
                    field_ticket_material_type: {
                        data: {
                            type: "taxonomy_term--material_type",
                            id: values["__material_type"]
                        }
                    }, // this is a simple enough query and mapping

                    field_ticket_status: {
                        data: {
                            type: "taxonomy_term--ticket_status",
                            id: defaultTicketData.status
                        }
                    },
                    /* READ FROM BACKEND */
                    field_ticket_requester: {
                        data: {
                            type: "user--user",
                            id: props.session.userUUID, //window.localStorage.getItem("userUUID"), // << this should come from the user-data
                        }
                    },
                    field_ticket_sales_org: {
                        data: {
                            type: "sales_org--sales_org",
                            id: props.session.salesOrgUUID || "6207be6e-85a2-46e3-9ad6-c07fec3aa8a8", // << this should come from the user-data
                        }
                    },

                    /* FIELDS WE MAY NEED TO ADD HERE but come from queries with data from above */
                    field_ticket_ticketing_system: {
                        "data": {
                            type: "ticketing_system--ticketing_system",
                            id: props.session.ticketingUUID,// window.localStorage.getItem( "ticketingUUID" )
                        }
                    },

                    field_ticket_attachments: {
                        data: attachments,
                    }
                }
            }
        }

        myHeaders.append( "Content-Type", "application/vnd.api+json" );
        myHeaders.append( "Accept", "application/vnd.api+json" );
        myHeaders.append( "Authorization", "Bearer " + window.localStorage.getItem( "token" ) );

        const body = JSON.stringify( objectToSend );

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body,
            redirect: 'follow'
        };
        const urlToSend = BackendURL + "/jsonapi/ticket/ticket";

        fetch( urlToSend, requestOptions )
            .then( response => response.json() )
            .then( result => {
                if ( result && result.errors === undefined ) {
                    const ticketData = {
                        assigned: result.data.relationships.field_ticket_assignee.data ? result.data.relationships.field_ticket_assignee.data : "unassigned",
                        attachments: result.data.relationships.field_ticket_attachments.data,
                        author: result.data.relationships.field_ticket_requester.data ? result.data.relationships.field_ticket_requester.data : values["Author"],
                        requestedDate: result.data.attributes.field_ticket_requested_date,//result.data.attributes.created.substr( 0, 10 ),
                        description: descriptionOutput,
                        dueDate: null,
                        jobTitle: values["Job Position"],
                        originalRequester: values["Original Requester"],
                        materialType: result.data.relationships.field_ticket_material_type.data ? result.data.relationships.field_ticket_material_type.data : values["materialType"],
                        necessityDate: result.data.attributes.field_ticket_date_needed_by ? result.data.attributes.field_ticket_date_needed_by : values["When is the deadline for the request?"],
                        resolution: null,
                        resource: "", // TODO: Check this out.
                        responsible: "",
                        salesOrg: result.data.relationships.field_ticket_sales_org.data ? result.data.relationships.field_ticket_sales_org.data : values["Sales Org"],
                        status: result.data.relationships.field_ticket_status.data ? result.data.relationships.field_ticket_status.data : "TODO",
                        subject: result.data.attributes.summary,
                    }

                    props.updateTicketInList( ticketData )
                    return true;
                } else {
                    return false;
                }
            } )
            .then( ( verify ) => {
                if ( verify === true ) {
                    setShowVerification( true );
                    setVerificationMessage( "Your request has been sent successfully, this screen will close automatically shortly." )
                    setTimeout( () => {
                        props.hideTicketForm();
                        setShowConfirmPanel( false );
                        setShowVerification( false )
                    }, 4000 )
                } else {
                    setShowVerification( true );
                    setVerificationMessage( "An error has occurred. Please wait a bit and try again later." )
                    setTimeout( () => {
                        setShowVerification( false );
                    }, 2000 )
                }
            } )
            .catch( error => console.error( 'Error: ', error ) );

    }

    const WhenFieldChanges = ( { field, becomes, isNot, set, to } ) => (
        set.map( ( item, index ) => {
            return <Field name={ item } subscription={ {} } key={ index }>
                { (
                    // No subscription. We only use Field to get to the change function
                    { input: { onChange } }
                ) => (
                    <FormSpy subscription={ {} }>
                        { () => {
                            return <OnChange name={ field }>
                                { value => {
                                    const testBecomes = value === becomes
                                    const testIsNot = value !== isNot
                                    if ( becomes ? testBecomes : testIsNot ) {
                                        onChange( to );
                                    }
                                } }
                            </OnChange>

                        } }
                    </FormSpy>
                ) }
            </Field>
        } )
    );

    return <>
        <StyledButton
            className="button button__request"
            onClick={ () => {
                props.showTicketForm( [] )
            } }>
            Click here for a Request
        </StyledButton>
        <StyledModal show={ props.visibleTicketForm }
                     onHide={ props.hideTicketForm }
                     size="lg"
                     backdrop="static"
        >
            <StyledModalHeader closeButton className={ "with-close-button" }>
                <Modal.Title>New Material Request</Modal.Title>
            </StyledModalHeader>
            <Modal.Body>
                <Form
                    onSubmit={ onSubmit }
                    initialValues={ {} }
                >
                    { ( props ) => {
                        const { handleSubmit, /*form, submitting, pristine,*/ values } = props
                        return <StyledForm onSubmit={ handleSubmit }>
                            <WhenFieldChanges
                                field="materialType"
                                isNot={ "Product promotional marketing material" }
                                set={ [
                                    "Reference of product for the image",
                                    "Images Description",
                                    "Image Usage",
                                    "Reference of product for the brochure",
                                    "Brochure Description",
                                    "Reference of product for the advertisement",
                                    "Advertisement Description",
                                    "Reference of product for the booth layout",
                                    "Booth layout Description",
                                    "Booth layout",
                                    "Reference of product for the roll up",
                                    "Roll up Description",
                                    "Product Promotional Marketing Type",
                                    "Product Promotional Marketing Material Type",
                                    "Product Promotional Marketing Type Option",
                                    "Product Promotional Marketing Material Type Option",
                                    "Product Promotional Marketing Type Description",
                                    "Product Promotional Marketing Material Type Description",
                                    "Content Language Option",
                                    "Translation Option", "Translation File", "Please indicate the language", "Translation Description",
                                    "translationSpecialFile",
                                ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="materialType"
                                isNot={ "Corporate" }
                                set={ [ "Corporate Project Description",
                                    "Project Needs",
                                    "Project Needs Other Description",
                                    "projectAttachment",
                                ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Image Usage"
                                isNot={ "Other" }
                                set={ [ "Other Usage Description" ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Product Promotional Marketing Material Type Option"
                                isNot={ "Images" }
                                set={ [ "Reference of product for the image", "Images Description", "Image Usage" ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Image Usage"
                                isNot={ "Booth layout" }
                                set={ [ "Reference of product for the booth layout", "Booth layout Description", "Booth layout",
                                    "Content Language Option",
                                    "Translation Option", "Translation File", "Please indicate the language", "Translation Description",
                                    "translationSpecialFile",
                                ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Booth layout"
                                isNot={ "Roll up" }
                                set={ [ "Reference of product for the roll up", "Roll up Description",
                                    "Content Language Option",
                                    "Translation Option", "Translation File", "Please indicate the language", "Translation Description",
                                    "translationSpecialFile",
                                ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Booth layout"
                                isNot={ "Custom" }
                                set={ [ "Custom Booth Layout Description", "boothLayoutFile"
                                ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Product Promotional Marketing Material Type Option"
                                isNot={ "Brochure" }
                                set={ [ "Reference of product for the brochure", "Brochure Description",
                                    "Content Language Option",
                                    "Translation Option", "Translation File", "Please indicate the language", "Translation Description",
                                    "translationSpecialFile",
                                ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Product Promotional Marketing Material Type Option"
                                isNot={ "Advertisement" }
                                set={ [ "Reference of product for the advertisement", "Advertisement Description",
                                    "Content Language Option",
                                    "Translation Option", "Translation File", "Please indicate the language", "Translation Description",
                                    "translationSpecialFile",
                                ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Product Promotional Marketing Material Type Option"
                                isNot={ "Roll up" }
                                set={ [ "Reference of product for the roll up", "Roll up Description",
                                    "Content Language Option",
                                    "Translation Option", "Translation File", "Please indicate the language", "Translation Description",
                                    "translationSpecialFile",
                                ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Product Promotional Marketing Material Type Option"
                                isNot={ "Booth layout" }
                                set={ [ "Reference of product for the booth layout", "Booth layout Description", "Booth layout",
                                    "Content Language Option",
                                    "Translation Option", "Translation File", "Please indicate the language", "Translation Description",
                                    "translationSpecialFile",
                                ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Product Promotional Marketing Material Type Option"
                                isNot={ "Other" }
                                set={ [ "Product Promotional Marketing Material Type Description" ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Content Language Option"
                                isNot={ "Translation" }
                                set={ [ "Translation Option", "Translation File", "Please indicate the language", "Translation Description" ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Translation Option"
                                isNot={ "Needs help" }
                                set={ [ "Translation File", "Please indicate the language", "Translation Description" ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Content Language Option"
                                isNot={ "Special" }
                                set={ [ "translationSpecialFile" ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Print Option"
                                isNot={ "Needs Help" }
                                set={ [ "Please Indicate hoy many copies" ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Product Promotional Marketing Material Type Option"
                                becomes={ "Images" }
                                set={ [ "Content Language Option", "Translation Option", "Translation File", "Please indicate the language", "Translation Description", "translationSpecialFile" ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="Project Needs"
                                isNot={ "Other" }
                                set={ [ "Project Needs Other Description" ] }
                                to={ undefined }
                            />
                            <WhenFieldChanges
                                field="materialType"
                                isNot={ undefined }
                                set={ [ "__material_type" ] }
                                to={ materialsList.find( item => item.name === values['materialType'] ) ? materialsList.find( item => item.name === values['materialType'] ).id : undefined }
                            />
                            {/*<WhenFieldChanges*/ }
                            {/*    field="Author"*/ }
                            {/*    isNot={undefined}*/ }
                            {/*    set={["__requester"]}*/ }
                            {/*    to={window.localStorage.getItem("userUUID")}*/ }
                            {/*    />*/ }
                            <Container fluid className={ (showConfirmPanel ? "d-none" : "show") + " FormPanel" }>
                                {/* USER DATA ROW 1*/ }
                                <Row>
                                    <Col md={ 4 }>
                                        <div className="text">
                                            <label htmlFor="Author">
                                                Name
                                            </label>
                                            <Field
                                                id="author"
                                                component="input"
                                                type="text"
                                                name="Author"
                                                defaultValue={ session.fullname || window.localStorage.getItem( "username" ) }
                                                disabled={ true }
                                                className={ "form-control" }
                                            />
                                        </div>
                                    </Col>
                                    <Col md={ 4 }>
                                        <div className="text">
                                            <label htmlFor="Email">
                                                Email
                                            </label>
                                            <Field
                                                id="email"
                                                component="input"
                                                type="text"
                                                name={ "Email" }
                                                defaultValue={ session.email || "N/A" }
                                                disabled={ true }
                                                className={ "form-control" }
                                            />
                                        </div>
                                    </Col>
                                    <Col md={ 4 }>
                                        <div className="text">
                                            <label htmlFor="Phone Number">
                                                Phone
                                            </label>
                                            <Field
                                                id="phone"
                                                component="input"
                                                type="text"
                                                name={ "Phone Number" }
                                                defaultValue={ session.phone || "N/A" }
                                                disabled={ true }
                                                className={ "form-control" }
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <br/>
                                {/* USER DATA ROW 2*/ }
                                <Row>
                                    <Col md={ 4 }>
                                        <div className="text">
                                            <Field
                                                id="jobPosition"
                                                component="input"
                                                type="hidden"
                                                name={ "Job Position" }
                                                defaultValue={ session.jobPosition || "N/A" }
                                                disabled={ true }
                                                className={ "form-control" }
                                            />
                                        </div>
                                        <div className="text">
                                            <InputField
                                                fieldLabel="Original Requester"
                                                fieldId="originalRequester"
                                                fieldType="text"
                                                fieldRequired={ false }
                                            />
                                        </div>
                                    </Col>
                                    <Col md={ 4 }>
                                        <div className="text">
                                            <label htmlFor="Company">
                                                Company
                                            </label>
                                            <Field
                                                id="company"
                                                component="input"
                                                type="text"
                                                name={ "Company" }
                                                defaultValue={ session.company || "N/A" }
                                                disabled={ true }
                                                className={ "form-control" }
                                            />
                                        </div>
                                    </Col>
                                    <Col md={ 4 }>
                                        <div className="text">
                                            <label htmlFor="Sales Org">
                                                Sales Organization
                                            </label>
                                            <Field
                                                id="salesOrg"
                                                component="input"
                                                type="text"
                                                name={ "Sales Org" }
                                                defaultValue={ session.salesOrg || "" }
                                                disabled={ true }
                                                className={ "form-control" }
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <hr/>
                                {/* REQUEST SUMMARY */ }
                                <Row>
                                    <Col md={ 12 }>
                                        <InputField
                                            fieldLabel="Request Subject"
                                            fieldId="requestSubject"
                                            fieldType="text"
                                            validator={ requiredField }
                                            hint="Please describe your request in one line (e.g. I need a brochure in German for a convention)."
                                            fieldRequired={ true }
                                        />
                                    </Col>
                                </Row>
                                {/* REQUEST DEADLINE */ }
                                <Spot when="Request Subject">
                                    <Row>
                                        <Col md={ 12 }>
                                            <DateField
                                                fieldLabel="When is the deadline for the request?"
                                                fieldId="requestDeadline"
                                                fieldType="date"
                                                validator={ composeValidators( requiredField, atLeastTwoWeeks ) }
                                                hint="If you need to make a request for service with a deadline of less than 2 calendars weeks,
                                                      please contact Global Communications for assistance."
                                                fieldRequired={ true }
                                            />
                                        </Col>
                                    </Row>
                                    <Spot when="When is the deadline for the request?">
                                        <hr/>
                                        {/* MATERIAL TYPE SELECTOR*/ }
                                        <Row>
                                            <Col md={ 12 }>
                                                <FieldGroup
                                                    groupName="materialType"
                                                    groupId="materialType"
                                                    groupLabel="Which kinds of material do you need?"
                                                    validator={ pickOne }
                                                >
                                                    { materialsList.map( ( item, index ) => {
                                                        return <RadioField
                                                            key={ index }
                                                            fieldId="materialType"
                                                            fieldLabel={ item.name }
                                                            fieldValue={ item.name }
                                                        />
                                                    } ) }
                                                    <input
                                                        type="hidden"
                                                        name="__material_type"
                                                        defaultValue={ materialsList.find( item => item.name === values['materialType'] ) ? materialsList.find( item => item.name === values['materialType'] ).id : undefined }
                                                    />
                                                </FieldGroup>
                                            </Col>
                                        </Row>

                                        {/* MATERIAL TYPE PRODUCT PROMOTIONAL MARKETING MATERIAL */ }
                                        <Condition when="materialType" is="Product promotional marketing material">
                                            <AdvertisingForm/>
                                        </Condition>

                                        {/* MATERIAL TYPE CORPORATE */ }
                                        <Condition when="materialType" is="Corporate">
                                            <CorporateForm values={values.materialType==="Corporate"? values: {}}/>
                                        </Condition>
                                    </Spot>
                                </Spot>

                                <Row>
                                    <Col md={ 12 }>
                                        <div className="buttons text-end">
                                            <Button
                                                className="button button__primary"
                                                type="button"
                                                onClick={ (event => {
                                                    event.preventDefault();
                                                    document
                                                        .querySelector( ".fade.modal" )//( ".fade.in.modal" )
                                                        .scrollTo( { top: 0, behavior: 'smooth' } );
                                                    setShowConfirmPanel( true );
                                                }) }
                                                disabled={ Object.keys( props.errors ).length > 0 || props.error !== undefined }>
                                                Validate request
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>

                            {/*<pre>{ JSON.stringify( values, 0, 2 ) }</pre>*/ }
                            <Container fluid className={ (showConfirmPanel ? "show" : "d-none") + " ConfirmPanel" }>
                                { showVerification === false && <Row>
                                    <Col md={ 12 }>
                                        <div style={ { fontSize: "24px", fontWeight: "bold" } }>Validate your request.
                                        </div>
                                        <p style={ { padding: "20px 10px" } }>
                                            Before sending it to us, please double check the data on this request, shown
                                            below for your convenience.<br/>
                                            Press <b>'Edit'</b> to go back and continue editing the form.<br/>
                                            Press <b>'Submit'</b> to send the request.
                                        </p>
                                        <div style={ { padding: "20px" } } className={ "Data " }>
                                            {
                                                Object.keys( values ).map( ( key, index ) => {
                                                    if ( key.includes( "__" ) ) {
                                                        return null
                                                    } else {
                                                        let valuesOutput;
                                                        if ( typeof values[key] !== "object" ) {
                                                            valuesOutput = [ values[key] ]
                                                        } else if ( values[key] instanceof Date ) {
                                                            valuesOutput = [ values[key].toISOString().substr( 0, 10 ) ]
                                                        } else if ( Array.isArray( values[key] ) ) {
                                                            if ( values[key][0] && values[key][0].hasOwnProperty( "name" ) ) {
                                                                valuesOutput = [ ...values[key] ].map( item => item.name )
                                                            } else {
                                                                valuesOutput = values[key];
                                                            }
                                                        }

                                                        if ( valuesOutput.length > 0 && valuesOutput[0] !== "N/A" ) {
                                                            return <div key={ index }>
                                                                <div className="key">
                                                                    <b>{ key }: </b>
                                                                </div>
                                                                <div className="value">
                                                                    { valuesOutput.map( ( item, index ) => (
                                                                        <p style={ { marginLeft: "20px" } }
                                                                           key={ index }>{ item }</p>) ) }
                                                                </div>
                                                                <br/>
                                                            </div>
                                                        } else {
                                                            return null
                                                        }
                                                    }
                                                } )
                                            }
                                        </div>
                                    </Col>
                                    <Col md={ 12 }>
                                        <div className="buttons text-end">
                                            <Button
                                                className="button button__primary"
                                                type="button"
                                                onClick={ () => {
                                                    document
                                                        .querySelector( ".fade.modal" )//( ".fade.in.modal" )
                                                        .scrollTo( { top: 0, behavior: 'smooth' } );
                                                    setShowConfirmPanel( false )
                                                } }
                                            >
                                                Edit
                                            </Button>&nbsp;&nbsp;&nbsp;
                                            <Button
                                                className="button button__primary"
                                                type="submit"
                                                disabled={ Object.keys( props.errors ).length > 0 || props.error !== undefined }>
                                                Submit
                                            </Button>
                                        </div>
                                    </Col>
                                </Row> }
                                { showVerification === true && <Row>
                                    <Col md={ 12 }>
                                        <p>
                                            { verificationMessage }
                                        </p>
                                    </Col>
                                </Row> }
                            </Container>

                        </StyledForm>
                    } }
                </Form>
            </Modal.Body>
        </StyledModal>
    </>
}

const mapStateToProps = ( state ) => {
    return {
        ticketFormData: state.tickets.ticketFormData,
        visibleTicketForm: state.tickets.visibleTicketForm,
        session: state.session,
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators( {
        showTicketForm: showTicketForm,
        hideTicketForm: hideTicketForm,
        updateTicketFormData: updateTicketFormData,
        persistTicketFormData: persistTicketFormData,
        updateTicketInList: updateTicketInList,
    }, dispatch )
}

export default connect( mapStateToProps, mapDispatchToProps )( TicketForm );
